module.exports = __webpack_public_path__ + "img/pcrown_red.145761ac.png";